export var isRepeater = function (param) {
    return 'data' in param;
};
export var isMultiStateBox = function (param) {
    return 'currentState' in param;
};
export var isEventHandler = function (name) {
    return name.startsWith('on');
};
var imperatives = {
    disabled: {
        on: 'disable',
        off: 'enable',
    },
    hidden: {
        on: 'hide',
        off: 'show',
    },
    collapsed: {
        on: 'collapse',
        off: 'expand',
    },
};
export var getImperative = function (key) {
    return imperatives[key];
};
export var isImparative = function (key) {
    return key in imperatives;
};
export var isNestedAttributes = function (observableValue) {
    return typeof observableValue === 'object';
};
//# sourceMappingURL=helpers.js.map